/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_ComebackInputs */

const en_portal_goal_comeback = /** @type {(inputs: Portal_Goal_ComebackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back from injury`)
};

const pl_portal_goal_comeback = /** @type {(inputs: Portal_Goal_ComebackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powrót po kontuzji`)
};

/**
* | output |
* | --- |
* | "Back from injury" |
*
* @param {Portal_Goal_ComebackInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_comeback = /** @type {((inputs?: Portal_Goal_ComebackInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_ComebackInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_comeback(inputs)
	return en_portal_goal_comeback(inputs)
});